import React, { useEffect, useState } from "react";
import {
  addEducation,
  deleteEducation,
  editEducation,
  getEducation
} from "contexts/API/CommonSetting/MasterData";

import MaterialTable from "components/Table/MaterialTable";
import { useSweetAlert } from "components/Alert/SweetAlert";

const Education = props => {
  const { sweetAlerts } = useSweetAlert();
  const [columns] = useState([
    {
      title: "educationId",
      field: "educationId",
      hidden: true
    },
    {
      title: "วุฒิการศึกษา",
      field: "detail",
      cellStyle: {
        minWidth: "600px"
      }
    }
  ]);

  const [data, setData] = useState([]);
  useEffect(() => {
    getEducation()
      .then(result => {
        setData(result.data.data);
      })
      .catch(err => {
        sweetAlerts.error("ไม่สามารถดึงข้อมูล", err.toString());
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const optionsTable = { pageSize: 10 };
  return (
    <MaterialTable
      title={"วุฒิการศึกษา"}
      options={optionsTable}
      columns={columns}
      data={data}
      editable={{
        onRowAdd: newData =>
          new Promise((resolve, reject) => {
            addEducation(newData.detail)
              .then(result => {
                //console.log("result>>",result);
                newData.educationId = result.data.data.educationId;
                setData([...data, newData]);
                sweetAlerts.success("เพิ่มข้อมูลเรียบร้อยแล้ว");
              })
              .catch(err => {
                sweetAlerts.error("ไม่สามารถเพิ่มข้อมูลได้", err.toString());
              });

            resolve();
          }),
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve, reject) => {
            const dataUpdate = [...data];
            const index = oldData.tableData.id;
            dataUpdate[index] = newData;

            editEducation(oldData.educationId, newData.detail)
              .then(result => {
                sweetAlerts.success("แก้ไขข้อมูลเรียบร้อยแล้ว");
                setData([...dataUpdate]);
              })
              .catch(err => {
                const errorMsg = err.response?.data?.desc || err.message || "เกิดข้อผิดพลาด";
                sweetAlerts.error("ไม่สามารถแก้ไข อปท.", errorMsg);
              });
            resolve();
          }),
        onRowDelete: oldData =>
          new Promise((resolve, reject) => {
            const dataDelete = [...data];
            const index = oldData.tableData.id;
            dataDelete.splice(index, 1);

            deleteEducation(oldData.educationId)
              .then(result => {
                sweetAlerts.success("ลบข้อมูลเรียบร้อยแล้ว");
                setData([...dataDelete]);
              })
              .catch(err => {
                sweetAlerts.error("ไม่สามารถลบข้อมูลได้", err.toString());
              });
            resolve();
          })
      }}
    />
  );
};
export default Education;
